<div class="mijn-login-template-background">
    <ap-header
        layout="medium"
        variant="standalone"
        [logoLink]="'mijn.login.template.retail-home.link' | apContent"
        [logoAriaLabel]="'mijn.login.template.logo.aria-label' | apContent"
    >
    </ap-header>
    <div class="mijn-login-template">
        <main id="main-content">
            <section>
                <ap-grid-row [apFullBleed]="true">
                    <ap-grid-col [xs]="12">
                        <div class="mijn-login-template__login-wrapper">
                            <div class="mijn-login-template__card-wrapper">
                                <ap-card>
                                    <ng-container *ngTemplateOutlet="loginCardContent"></ng-container>
                                </ap-card>
                                @if (showExtraContentCard) {
                                    <ng-container *ngTemplateOutlet="extraCardContent"></ng-container>
                                }
                            </div>
                            <background-theme name="mijn-login"></background-theme>
                        </div>
                    </ap-grid-col>
                </ap-grid-row>
            </section>
        </main>
        <footer>
            <div class="mijn-login-template__footer" data-bb="footer-links">
                <a [href]="'mijn.login.template.footer.contact.url' | apContent">{{
                    'mijn.login.template.footer.contact.title' | apContent
                }}</a>
                <a [href]="'mijn.login.template.footer.safe-banking.url' | apContent">{{
                    'mijn.login.template.footer.safe-banking.title' | apContent
                }}</a>
                <a [href]="'mijn.login.template.footer.privacy.url' | apContent">{{
                    'mijn.login.template.footer.privacy.title' | apContent
                }}</a>
                <a [href]="'mijn.login.template.footer.disclaimer.url' | apContent">{{
                    'mijn.login.template.footer.disclaimer.title' | apContent
                }}</a>
            </div>
            @if (displayEndorsement) {
                <div class="mijn-login-template__illustration" role="presentation">
                    <ap-illustration name="volksbank" width="186px" height="42px" class="ap-display-block"></ap-illustration>
                </div>
            }
        </footer>
    </div>
</div>

<ng-template #loginCardContent>
    @if (showMultipleTabs) {
        @if (showNotification) {
            <ap-notification [closeable]="true" (closeClicked)="dismissNotification()" data-bb="infoMultiLogin">
                <ap-content key="mijn.login.multibank.notification"></ap-content>
            </ap-notification>
        }
        <ap-tabs (selectionChanged)="changedTab($event)">
            <ap-tab [title]="'mijn.login.multibank.tab.asn' | apContent">
                <ng-container *ngTemplateOutlet="mainContent"></ng-container>
            </ap-tab>
            <ap-tab [title]="'mijn.login.multibank.tab.sns' | apContent">
                <ng-container
                    *ngTemplateOutlet="bankTabContent; context: { bank: 'sns', actionFn: navigateToSns.bind(this) }"
                ></ng-container>
            </ap-tab>
            <ap-tab [title]="'mijn.login.multibank.tab.reb' | apContent">
                <ng-container
                    *ngTemplateOutlet="bankTabContent; context: { bank: 'reb', actionFn: navigateToReb.bind(this) }"
                ></ng-container>
            </ap-tab>
            <ap-tab [title]="'mijn.login.multibank.tab.blg' | apContent">
                <ng-container
                    *ngTemplateOutlet="bankTabContent; context: { bank: 'blg', actionFn: navigateToBlg.bind(this) }"
                ></ng-container>
            </ap-tab>
        </ap-tabs>
    } @else {
        <ng-container *ngTemplateOutlet="mainContent"></ng-container>
    }
</ng-template>

<ng-template #mainContent>
    @if (title) {
        <h1>{{ title }}</h1>
    }
    <ng-content select="[header]"></ng-content>
    <ng-content></ng-content>
</ng-template>

<ng-template #bankTabContent let-bank="bank" let-actionFn="actionFn">
    <h3>{{ 'mijn.login.multibank.tab.' + bank + '.title' | apContent }}</h3>
    <p>{{ 'mijn.login.multibank.tab.' + bank + '.text' | apContent }}</p>
    <ap-button type="submit" (onClick)="actionFn()">
        {{ 'mijn.login.multibank.tab.' + bank + '.button' | apContent }}
    </ap-button>
</ng-template>

<ng-template #extraCardContent>
    <div class="mijn-login-template__extra-card">
        <ap-card>
            <ng-content select="[extra]"></ng-content>
        </ap-card>
    </div>
</ng-template>
